import Link from "next/link";
import * as React from "react";

import { AccessCheck } from "@/components/access-check";
import { ExaminePlusLink } from "@/components/cta";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface PaidPillProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function PaidPill({ className }: PaidPillProps) {
	return (
		<Tooltip>
			<TooltipTrigger className={cn(className)} asChild>
				<span className="mr-auto inline-flex">
					<AccessCheck
						feature={["examine_database", "study_summaries", "supplement_guides"]}
						featureCheck="any"
						cta={
							<Link href="/plus-info">
								<Badge variant="premium" size="sm">
									Examine+ Content
								</Badge>
							</Link>
						}
					>
						<ExaminePlusLink
							trackDetails={{
								location: "Jumbotron Badge",
								label: "Examine+ Content",
							}}
						>
							<Badge variant="premium" size="sm">
								Examine+ Content
							</Badge>
						</ExaminePlusLink>
					</AccessCheck>
				</span>
			</TooltipTrigger>
			<TooltipContent variant="premium" className="font-medium leading-6">
				Examine is entirely self-funded, with no third-party ads or ties to food and supplement
				companies.{" "}
				<span className="font-semibold">
					Examine+ unlocks the Examine Database, Study Summaries, and Supplement Guides.
				</span>
			</TooltipContent>
		</Tooltip>
	);
}
